module.exports = __webpack_public_path__ + "img/1234567895.98167f9f.png";